export default [
	{
		// login form page
		companiesLabel: "COMPANIES",
		cardUsersLabel: " CARD HOLDERS",
		idleBrowserTitle: "Session Expired",
		idleBrowserMessage: "You have left this browser idle for 30 minutes.",
		idleBrowserTimeLeft: "15 second left.",
		confirmButtonLabel: "CONFIRM",
		cardUserFieldLabel: "E-mail",
		userFieldLabel: "User",
		passwordFieldLabel: "Password",
		loginTitle: "Access your account",
		loginHelpLink: "Couldn't login?",
		loginButtonLabel: "LOGIN",
		customerHelpPopup:
			"If you are one of our customers or an affiliate partner you can log into your Up Online account using the information in the welcome e-mail you received shortly after signing the contract. <br/> <br /> The default log in information are  <br /> <b> User </b> = your client/ partner unique code; <br /> <b> Password </b> = your company's VAT number. <br />You may change your password after your first log in.  ",
		userLoginHelpPopup:
			"Hi! We've changed the login method for card holders. Please create a new account using your e-mail address and your personal information. <br/> You will be able to use the same account to log in to the Up mobile app.	",
		downloadAppMessage: "Download the new mobile app Up Mobil",
		loadingPopupMessage: "Please wait. The page is loading...	",
		erroMessage_bad_credentials: "Invalid username or password",
		erroMessage_user_blocked: "User is blocked",
		erroMessage_invalid_grant: "Invalid username or password",
		erroMessage_invalid_login: "Invalid username or password",
		erroMessageResetPassword_bad_credentials:
			"Invalid company code or fiscal core",
		erroMessage_undefined:
			"Server error. <br /> Please wait a few minutes and try again",
		erroMessage_invalid_client:
			"Server error. <br /> Please wait a few minutes and try again",
		erroMessage_server_error:
			" Server error. <br /> Please wait a few minutes and try again",
		erroMessageResetPassword_server_error:
			" Server error. <br /> Please wait a few minutes and try again",
		// create account page
		selectCardTitle: "Select your Up Card",
		uploadFileLabel: "Upload file",

		cardNumberFieldLabel: "Fill in your card number",
		registrationCodeFieldLabel:
			"Fill in the last 6 digits of your personal ID number",
		registrationCheckDataTitle: "Check information or edit data",
		surnameFieldLabel: "Surname",
		lastNameField: "Name",
		emailField: "E-mail",
		mobileField: "Mobile number",
		setPasswordTitle: "Set your password",
		passwordField: "Password",
		confirmPasswordField: "Confirm password",
		invalidPasswordMessage: "Invalid password",
		successMessageTitle: "Congrats!",
		registrationSuccessMessage: "We've sent you a welcome email at",
		// forgot password
		resetPasswordSuccessMessage: "Your password has been successfully reset",
		companyCodeLabel: "Company code",
		fiscalCodeLabel: "Fiscal code",
		resetPasswordSuccessMessageCompany:
			"We've sent you an email with the password reset link",
		// cookies box
		cookiesBoxText:
			"Our site uses cookies for displaying personalized content and for te monitoring service provided by Google for traffic monitoring.			<br />Please read our cookies policy and review you cookies preferences.",
		cookiesAcceptBotton: "ACCEPT",
		cookiesCookiePreferences: "COOKIE PREFERENCES",
		notificationsTitle: "Notifications options",
		notificationsTransactionalLabel: "Transactional notifications",
		notificationsMarketingTitle: "Marketing notifications",
		notificationsLabel: "Notifications",
		notificationsSMSLabel: "SMS",
		notificationsEmailLabel: "E-mail",
		notificationsCongrats:
			"You can now check your balance and discover partners that accept your card",
		completeRegistrationLogin: "USE THE APP!",
		// page name
		dashboardName: "Dashboard",
		cardsName: "Cards",
		servicesName: "Services",
		faqName: "FAQ",
		settingsName: "Settings",
		myAccountName: "My Account",
		contactName: "Contact",
		termsAndConditionsName: "Terms and conditions",
		personalDataPolicyName: "Personal data policy",
		logoutName: "Logout",
		// beneficiary dashboard
		cardBalanceBubbleTitle: "Card balance",
		balanceBubbleTitle: "My balance",
		currency: "&euro;",
		spentAmountMessage: "You’ve spent {amount} lei since your last top up",
		offersButtonLabel: "Offers",
		partnersButtonLabel: "Partners",
		recommendPartnersButtonLabel: "Recommend partener",
		expiringFundsTitle: "Expiring funds",
		transactionsListTitle: "TRANSACTION LIST",
		transactionListPeriodWeek: "{index} weeks ago",
		transactionListPeriodThisWeek: "This week",
		transactionStatsTitle: "Transaction stats",
		transactionNoTransactionsMessage: "You don't have any transactions yet",
		transactionStatsDDLThisMonth: "This month",
		transactionStatsDDLLastMonth: "Last month",
		transactionStatsDDLLastMonths: "Last {index} months",
		transactionStatsDDLLast3Month: "Last 3 months",
		transactionStatsDDLLastYear: "Last year",
		transactionStatsDDLCustom: "Custom",
		loadingsReport: "Loadings per card holder",
		downloadReport: "Download loadings report",
		// beneficiary cards
		cardsPageTitle: "MY CARDS",
		cardValidLabel: "Valid until",
		// card svg text:
		expireAtLabel: "Expire at ",
		soldLabel: "Sold: ",
		// beneficiary services
		servicesPageTitle: "SERVICES",
		serviceName1: "RECOMMEND A PARTNER",
		serviceName2: "Download the app",
		serviceName3: "MEMBER GET MEMBER",
		serviceName4: "DEDICATED OFFERS",
		serviceName5: "PARTNER NETWORK AND MAPS",
		serviceName6: "FEEDBACK",
		textRecommendAParterner:
			"Do you want recipients to use Up Romania vouchers to a company that is not yet in our affiliate network? \n It may be a store, a restaurant, a crèche, an accommodation unit or maybe a travel agency. Let us know and we'll contact them in no time.",
		placeholderCompanyName: "Company Name*",
		placeholderFieldOfActivity: "Field of activity*",
		placeholderDistrict: "District*",
		placeholderCity: "City*",
		placeholderNameAndSurname: "Name and surname*",
		placeholderPhone: "Phone*",
		placeholderEmployerName: "Employer's name*",
		placeholderEmail: "E-mail*",
		placeholderVerificationCode: "Verification code*",
		textButtonForm: "SEND",
		textMemberGetMember:
			"Recommend us a company that does not offer meal vouchers, and we reward you with gift vouchers.\nFill out the form below and earn Up Gift Vouchers from 50 lei, up to 330 lei, if the company you recommend begins to give its employees lunch vouchers.\nDepending on the number of employees you recommend, you can earn:",
		titleYourCoordinates: "YOUR COORDINATES",
		titleRecommendedCompanyDetails: "RECOMMENDED COMPANY DETAILS",
		placeholderMemberCompanyName: "Company Name*",
		placeholderMemberName: "Name*",
		placeholderMemberRole: "Role*",
		placeholderMemberDistrict: "District*",
		placeholderMemberCity: "City*",
		placeholderMemberPhone: "Phone*",
		placeholderMemberEmail: "E-mail*",
		placeholderComment: "Message*",
		placeholderMemberVerificationCode: "Verification code",
		textAcceptPrivacyPolicy:
			"I agree that the above data to be collected and used by Up Romania in accordance with the",
		textPrivacyPolicy: "Privacy Policy",
		textReadAndAgree: "I have read and I have agreed to the",
		textCampaignRegulations:
			'" Ai recomandat, ai castigat!" campaign regulations, including the Section 7 regarding the personal data policy.',
		textFeedback:
			"Parerea ta reprezinta un element important in procesul nostru de a imbunatati permanent serviciile pe care ti le oferim.",
		chooseOptionLabel: "Choose product...",
		noOffersMessage: "There are no offers to display at the moment.",
		// pin || card request message
		pinReqMsg:
			"You have already requested the PIN code. Please contact your employer for validation.",
		cardReqMsg:
			"You have already requested a new card. Please contact your employer for validation.",
		// confirm pin || card request message
		confirmPinReqMsg: "Are you sure you want to reissue your PIN code?",
		confirmCardReqMsg: "Are you sure you want to reissue a new card?",
		// error pin || card request message
		errorPinOrCardReqMsg:
			"There seems to be a server error. <br /> Please wait a few minutes and try again!",
		selectDate: "Select date interval",
		// Buttons card options
		activeCardText: "<br />  ACTIVATE <br /> CARD",
		blockCardText: "<br /> BLOCK<br /> CARD",
		unblockCardText: "<br /> UNBLOCK <br /> CARD",
		requestPinText: "<br /> REQUEST <br /> PIN",
		requestCardText: "<br /> REQUEST <br /> CARD",
		faqText: "<br />FAQ",
		// Success message
		successMsg:
			"Your {PIN} request was successfully sent<br />to your employer and will be reissued after their approval",
		// Chart
		expenseText: "Expense",
		soldText: "Sold",
		// Download Apps
		downloadApps: "Download the mobile app Up Mobil",
		// Setting Items Title
		settingPageTitle: "SETTINGS",
		settingItem1: "MY ACCOUNT",
		settingItem2: "MARKETING NOTIFICATIONS",
		settingItem3: "CHANGE PASSWORD",
		settingItem4: "DELETE ACCOUNT",
		// Change Password Form
		placeholderOldPassword: "Old password",
		deleteAccountText: "Are you sure you want to delete your account?",
		passwordCriteria1Text: "Minimum 8 characters",
		passwordCriteria2Text: "At least one letter character",
		passwordCriteria3Text: " At least one numeric digit",
		// Read More || Read less
		readMore: "Read more",
		readLess: "Read less",
		// Confirm activate OR block OR unblock card request message
		confirmActvatedCardReqMsg: "Are you sure you want to active your card?",
		confirmBlockCardReqMsg: "Are you sure you want to block your card?",
		confirmUnblockCardReqMsg: "Are you sure you want to unblock your card?",
		msgEmailSuccess: "Your email was sent with success!",
		notificationMessage: "You don't have any messages!",
		// customer page
		// menu items
		ordersName: "Orders",
		beneficiariesName: "Beneficiaries",
		deliveryPointsName: "Delivery points",
		deliveryPointsDescription: "View your delivery points",
		productTypePaper: "Paper vouchers",
		productTypeCard: "Cards",
		deliveryPointAddressTitle: "Address",
		deliveryPointAddressStreet: "Street",
		deliveryPointAddressStreetDetail: "Street detail",
		deliveryPointAddressCity: "City",
		deliveryPointAddressDistrict: "District",
		deliveryPointAddressPostalCode: "Postal code",
		deliveryPointContactTitle: "Contact person",
		deliveryPointContactSurname: "First name",
		deliveryPointContactName: "Last Name",
		deliveryPointContactFullName: "Name",
		deliveryPointContactEmail: "Email",
		deliveryPointContactMobile: "Phone number",
		deliveryPointNoBeneficiaries: "Number of beneficiaries",
		newOrderName: "New order",
		settingCompanyItem1: "Company details",
		settingCompanyItem2: "My Contracts",
		settingCompanyItem3: "Change password",
		averageChartLabel: "Value",
		countChartLabel: "No. of transactions",
		pendingInvoicesTitle: "Awaiting payment",
		invoiceNumberHeader: "Number",
		invoiceDateHeader: "Date",
		invoiceAmountHeader: "Value",
		invoiceDownloadPDFHeader: "Download PDF",
		invoiceDownloadXMLHeader: "Download XML",
		seeAllInvoicesButtonLabel: "SEE ALL",
		customerDashboardCardStats: "Order summary",
		statsCardsActive: "Active cards",
		statsCardsBlocked: "Frozen cards",
		statsCardsInactive: "Not yet activated cards",
		statsCardsSMS: "Cards with SMS option",
		recommendationsTitle: "Recommendations",
		averageTransactionAmount: "Average basket",
		averageTransactionNumber: "Average no. of transactions",
		usageVolumeChartTitle: "Transactions volume",
		usagePerRegion: "Transactions volume by district",
		topSellers: "Top affiliates",
		noTransactionsTitle: "There are no transactions for the selected period",
		noTransactionsMessage:
			"Please select a new period for transactions statistics.",
		downloadLinkText: "Download",
		noInvoicesMessage: "There are no invoices for this product.",
		// Dashboard
		dashboardInfoTitle_TOTAL_ORDERS_COUNT: "{value}",
		dashboardInfoTitle_TOTAL_ORDERS_AMOUNT: "{value} &euro;",
		dashboardInfo_TOTAL_ORDERS_COUNT:
			"orders placed from <br/> the beginning of the year",
		dashboardInfo_TOTAL_ORDERS_AMOUNT:
			"ordered from <br/>  the beginning of the year",
		productBrand_gift: "Gift",
		productBrand_rewards: "Rewards",
		// Orders
		deliveryAddress: "Delivery address",
		invoiceAddress: "Invoicing address",
		product: "Product",
		ordersTableHeaderDate: "Date",
		ordersTableHeaderNumber: "Number",
		ordersTableHeaderProduct: "Product",
		ordersTableHeaderType: "Type",
		ordersTableHeaderAmount: "Value",
		ordersTableHeaderStatus: "Status",
		ordersTableHeaderAddress: "Delivery address",
		ordersTableHeaderInvoice: "Invoice",
		ordersTableHeaderTrack: "Track & Trace",
		ordersTableHeaderProform: "Proforma",
		proformNumber: "Proform number",
		numberTotalTickets: "Total number of vouchers ",
		numberTotalCards: "Total number of cards ",
		nominalValue: "Total nominal value",
		nominalValueRewards: "Total nominal value",
		groupTickets: "Voucher grouping",
		logo: "Logo",
		messageTicket: "Voucher message",
		totalPayment: "Total",
		beneficiariesTitle: "Card beneficiaries",
		beneficiariesDescription: "Manage you card beneficiaries",
		beneficiariesInfoTitle: "Do you want to add a new beneficiary?",
		noOrdersMessage:
			"There are no orders for the period selected. Please select another period for the date filter.",
		beneficiariesInfoMessage:
			"Beneficiaries are added after the creation fo their first card. If you have new employees, go to New Order menu to place an order for their new cards",
		noBeneficiariesInfoMessage:
			"There are no benficiaries for the selected filters.",
		beneficiariesFilterTitle: "Filter beneficiaries",
		beneficiariesFilterCardType: "Product name",
		beneficiariesFilterCardStatus: "Card status",
		beneficiariesFilterProductType: "Product type",
		beneficiariesFilterDeliveryAddress: "Delivery address",
		beneficiariesFilterHddid: "Search by name or employee ID#",
		beneficiariesFileUploadText: "Upload file with columns: hddid, first name, last name",
		beneficiariesFilterKeyword: "Search by name or employee ID#",
		beneficiariesTableTextOnCard: "Text on card",
		beneficiariesTableDetails: "Details",
		beneficiariesTableAmount: "Amount",
		beneficiariesTableSurname: "First name",
		beneficiariesTableName: "Last name",
		beneficiariesTableCNP: "employee ID#",
		beneficiariesTableCard: "Card",
		beneficiariesTableCardStatus: "Card status",
		beneficiariesTableExpire: "Expire date",
		beneficiariesTableAction: "Actions",
		beneficiariesTableStatus: "Beneficiary status",
		beneficiariesTableSeeMore: "Details",
		beneficiariesTableDownload: "Download list",
		beneficiariesTableNoOfTickets: "Number of vouchers",
		beneficiariesTableTicketValue: "Amount",
		beneficiariesTableTotalValue: "Total value",
		beneficiariesTableAddress: "Address",
		beneficiariesTableAddress1: "Window text 1",
		beneficiariesTableAddress2: "Window text 2",
		beneficiariesTableAddressCity: "Window text 3",
		beneficiariesTableAddressPostalCode: "Window text 4",
		beneficiariesTableMobile: "Phone number",
		beneficiariesTableEmail: "Email",
		beneficiariesTableType: "Product Type",
		beneficiariesTableDigital_true: "Digital",
		beneficiariesTableDigital_false: "Physical",

		beneficiariesSelectAll: "Select all beneficiairies",
		beneficiariesDeselectAll: "De-select all beneficiaries",

		backButtonLabel: "Back",
		cardStatus_A: "Active",
		cardStatus_B: "Freeze",
		cardStatus_F: "Freeze",
		cardStatus_D: "Deactivated",
		cardStatus_C: "Not yet activated",
		cardStatus_J: "Cancelled",
		cardStatus_L: "Cancelled",
		cardStatus_X: "Expired",
		cardStatus_PF: "Proforma",
		cardStatus_E: "In production",
		cardStatus_I: "In production",
		cardStatus_M: "In production",
		cardStatus_N: "In production",
		cardStatus_O: "In production",
		cardStatus_P: "In production",
		cardStatus_R: "In production",
		cardStatus_S: "In production",
		cardStatus_RN: "Expires soon",
		cardStatus_RC: "Reeissue card",
		cardStatus_OH: "Freeze",
		cardStatus_RP: "Reissue PIN",
		cardStatus_: "Select...",
		cardStatus_unknown: "In production",
		productType_D: "Digital",
		productType_P: "Physical",
		productType_: "Select...",
		beneficiaryStatus_Active: "Active",
		beneficiaryStatus_Inactive: "Inactive",
		actionsText: "For the {count} beneficiaries selectated above you want to:",
		beneficiariesActionSelect: "Action",
		newOrderActionSelect: "For registration press +",
		cardsAction_CHOOSE: "Select...",
		cardsAction_ACT: "Activate selected cards",
		cardsAction_DEACT: "Deactivate selected cards",
		cardsAction_REPL: "Reissue selected cards",
		cardsAction_PIN: "Reissue PIN",
		cardsAction_VALIDATE_REPL: "Validate reissue card",
		cardsAction_VALIDATE_PIN: "Validate reissue PIN",
		cardsAction_REN: "Cancel reissue",
		cardsAction_ACT_ALL: "Activate all cards",
		cardsAction_BLOK: "Freeze selected cards",
		cardsAction_DEBLOK: "Unfreeze selected cards",
		cardsAction_CLO: "Order plastic for selected cards",
		cardsAction_DELETE_BENEFICIARY: "Delete selected beneficiaries",
		cardsActionDeactCardMessage:
			"Προχωράτε σε οριστική ακύρωση κάρτας και η ενέργεια αυτή θα είναι μη αναστρέψιμη. Είστε σίγουροι ότι θέλετε να προχωρήσετε;",
		// beneficiary details from client
		transferUserLabel: "Transfer",
		suspendUserLabel: "Deactivate",
		deleteUserLabel: "Delete",
		cnpFieldLabel: "employee ID#",
		saveChangesLabel: "Save",
		editButtonLabel: "Edit",
		cancelChangesLabel: "Cancel modifications",
		deliveryPointLabel: "Delivery address",
		cardNumberLabel: "Card number:",
		cardExpiryLabel: "Expires at:",
		reissueCardButtonLabel: "REISSUE CARD",
		reissuePINButtonLabel: "REISSUE PIN",
		validateReissueCardButtonLabel: "VALIDARE REISSUE CARD",
		validateReissuePINButtonLabel: "VALIDARE REISSUE PIN",
		notificationsChooseLabel: "SMS notifications for transactions an top-ups",
		notificationsChooseOptionYes: "Yes",
		notificationsChooseOptionNo: "No",
		beneficiaryOrderHistory: "Actions history",
		orderType_NEW: "Order cards",
		orderType_NEWCR: "Card loading",
		orderType_PIN: "Reissue PIN",
		orderType_REPL: "Reissue card",
		orderType_VALIDATE_REPL: "Validate reissue card",
		orderType_VALIDATE_PIN: "Validate reissue PIN",
		orderType_MODIFY_DATA: "Modify beneficiary infos",
		lastToppingUpLabel: "Last top-up: ",
		replacementLabel: "Replacement",
		confirmActionBeneficiary_PIN:
			"Are you sure you want to reissue the PIN for the {product} card? ",
		confirmActionBeneficiary_REPL:
			"Are you sure you want to reissue the {product} card? ",
		confirmActionBeneficiary_SMS:
			"Are you sure you want tu change the SMS option for the {product} card? ",
			confirmActionBeneficiary_DELETE:
			"You have chosen to delete this beneficiary. <br /><br /> Attention! This action is irreversible, and you will not have access to future information regarding the beneficiary once you delete them. The beneficiary's card will remain active, and they will be able to use the card. <br /><br /> Are you sure you want to delete this beneficiary? <br />",
		confirmActionBeneficiary_DELETE_BENEFICIARY:
			"You have chosen to delete the selected beneficiaries. <br /><br /> <b>Attention!</b> This action is irreversible, and you will not have access to future information regarding the beneficiary once you delete them. The beneficiary's card will remain active, and they will be able to use the card. <br /><br /> Are you sure you want to delete the beneficiaries? <br />",
		confirmActionBeneficiary_INACTIVATE:
			"Are you sure you want to deactivate this beneficiary? <br /> You will be able to reactivate the beneficiary later.",
		confirmActionBeneficiary_ACTIVATE:
			"Are you sure you want to activate this beneficiary?  ",
		successActionBeneficiary_PIN:
			"The reissue PIN request for the {product} card was registered. You can check the status of this request in the Orders menu.",
		successActionBeneficiary_REPL:
			"The reissue card request for the {product} card was registered. You can check the status of this request in the Orders menu.",
		successActionBeneficiary_DELETE:
			"The beneficiary was successfully deleted.",
		successActionBeneficiary_INACTIVATE:
			"The beneficiary was successfully deactivated.",
		successActionBeneficiary_SMS:
			"The SMS option for the {product} card was successfully registered",
		errorActionBeneficiary_CRRR:
			"There is another reissue for the {product} card requested today.",
		errorActionBeneficiary_ASFI: "The SMS option you chosed is invalid.",
		errorActionBeneficiary_CRBS: "The reissue request is invalid.",
		errorActionBeneficiary_CRNF:
			"The card for which you requested the reissue does not exist.",
		errorActionBeneficiary_409:
			"There is another reissue for the {product} card requested today.",
		errorActionBeneficiary_CHOOSE:
			"Please select an action you want to perform.",
		errorActionBeneficiary_NOADDRESS: "Please select the delivery address.",
		errorActionBeneficiary_PROFORM:
			"The system encountered an error during the proform downloading process. Please try again later from the Orders menu.",
		errorActionBeneficiary_500:
			"Server error. <br /> Please wait a few minutes and try again.",
		errorActionBeneficiary_ERROR:
			"During the request there were encoutered the following errors: ",
		errorActionBeneficiary_NO_FILE: "You must upload a valid order file. ",
		errorActionBeneficiary_NO_DATA:
			"You must enter at least one beneficiary in order for the order to be placed. ",
		errorActionBeneficiary_NO_POSTPONE_DATE:
			"You must choose a date starting tomorrow at which your proforma should be generated. ",
		errorActionBeneficiary_VALUE: "The amount value is incorrect.",
		errorActionBeneficiary_FIRSTNAME:
			"The first name value is incorrect. It must contain only latin characters",
		errorActionBeneficiary_LASTNAME:
			"The last name value is incorrect. It must contain only latin characters",
		errorActionBeneficiary_VALUE_MANDATORY: "The amount value is mandatory.",
		errorActionBeneficiary_VALUE_MAX_REWARDS:
			"The amount value should not exceed 150 &euro;.",
		errorActionBeneficiary_VALUE_MAX_PAPER:
			"The amount value should not exceed 175 &euro; due to the limitation of the number of tichets.",
		errorActionBeneficiary_MAX_TICKETS_BOOKLET:
			"The number of vouchers in the booklet exceeds 35 vouchers",
		errorActionBeneficiary_NO_MONTH: "Please select the month for you top-up. ",
		errorActionBeneficiary_EMAIL_INVALID: " Email invalid ",
		errorActionBeneficiary_MOBILE_INVALID: " Mobile phone invalid ",
		errorActionBeneficiary_EMAIL_PHONE_MANDATORY:
			" Email or mobile number is mandatory ",
		errorActionBeneficiary_EMAIL_PHONE_UNIQUE: " Only email or phone number is permitted ",
		errorActionBeneficiary_PHONE_UNIQUE: " The mobile phone for all beneficiaries must be unique",
		errorActionBeneficiary_LOAD_VALUE:
			"It is not allowed to use 3 digits value (it is allowed up to 99 euros)",
		errorActionBeneficiary_MILLESIME:
			"Due to scheduled upgrades on our platform, the order placement will be temporarily unavailable. It will be fully restored after 11:00. Thank you for your understanding.",
		errorActionBeneficiary_EMPTY:
			"You must add at least one beneficiary in order to submit the order",
		errorActionBeneficiary_TICKET:
			"There is an issue with the order you try to upload. <br /> Please contact us by opening a ticket here: <br /> <a href='https://uphellas.atlassian.net/servicedesk/customer/portal/15' target='_blank'> Business Portal Support - Jira Service Management (atlassian.net) </a>",
		reissuePINBeneficiaryTitle:
			"This beneficiary has requested {count} PIN requests",
		reissuePINBeneficiaryMessage:
			"See the requests below in the cards section in order to validate them.",
		reissueCardBeneficiaryTitle:
			"This beneficiary har requested {count} card requests",
		suspendedBeneficiaryTitle: "This beneficiary is deactivated.",
		suspendedBeneficiaryMessage: "Do you want to activate this beneficiary?",
		reactivateBeneficiaryButtonLabel: "ACTIVATE",
		actionConfirmMessage:
			"Confirm the list of beneficiaries you selected for the action.",
		actionCLOMessage: "Τhe replaced card will be delivered to the address code {code}",
		actionSuccessMessage:
			"The <b>{action}</b> action was successfully registered.",
		"CARD.ERROR.EMPTY.LIST":
			"The order you sent does not include any beneficiaries with over 0 vouchers.",
		"CARD.ERROR.CONFIG":
			"There was an issue with your order, as no specific address appears to be registered in our system. Please contact us via chat to resolve this problem. Thank you.",
		"CARD.NOT.VALIDSTATUS":
			"The card status for the beneficiary with id {name} is not right for the selected action.",
		"CARD.NOT.VALIDVIRTUAL":
			"The card for the beneficiary with id {name} must be a digital card for the selected action.",
		"CARD.NOT.FOUND":
			"The card for the beneficiary with id {name} was not found.",
		"CARD.NOT.PRODUCED":
			"The card was not produced.",
		"CARD.ERROR.NOT.FOUND":
			"The card for the beneficiary with id {name} was not found.",
		"CARD.ERROR.NOTFOUND":
			"The card for the beneficiary with id {name} was not found.",
		"CARD.NOT.VALIDTODAY":
			"The action selected for the beneficiary with id {name} was already requested today.",
		"CARD.ERROR.MANDATORY":
			"The {field} field is mandatory for the beneficiary with id {name}.",
		"CARD.ERROR.ALREADY":
			"The card for the beneficiary with id {name} has already been issued.",
		"CARD.ERROR.ALREADY.REPL":
			"Your request for replacement is already registered.",
		"CARD.ERROR.TRANSFER":
			"The beneficiary with id {name} is in transfer process from another company.",
		"CARD.ERROR.LENGTH":
			"The name is too long for the beneficiary with id {name}",
		"CARD.ERROR.LOAD.MONTH":
			"The number of vouchers in the booklet on the line {X} exceeds 35 vouchers",
		"CARD.ERROR.LOAD.VALUE":
			"The amount value for the beneficiary with id {name} is bigger than {field}",
		"CARD.ERROR.LOAD.VALUE.MIN":
			"The amount value for the beneficiary with id {name} is too small",
		"CARD.ERROR.MAX.YEARLY":
			"The total loaded amount per beneficiary {name} cannot be above 1.752€/year for Up EAT or 300€/year for Up Gift.",
		"CARD.ERROR.TOO.MANY.DIGITS": "The amount value for the beneficiary with id {name} must have at most 3 digits (including decimals)",
		"CARD.ERROR.NOT.VALID.REISSUE": "The card for the beneficiary with id {name} cannot pe reissued. Please contact UpHellas",
		"CARD.ERROR.ADDRESS.NOTFOUND":
			"The address code for the beneficiary with id {name} is mandatory",
		"CARD.ERROR.INVALID":
			"The {field} field is invalid for the beneficiary with id {name}.",
		"CARD.ERROR.DUPLICATE": "The value {name} is duplicate",
		"CARD.ERROR.LATIN":
			"The name of the beneficiary with id {name} must contain only latin characters.",
		"CARD.ERROR.SPACE": "The display text must contain at least 2 words.",
		"CARD.EXPIRY.TODAY": "The replacement you have selected cannot be completed today due to card’s expiry date. Please proceed again with their replacements tomorrow.",
		"CARD.ERROR.VALUE.MAX.REWARDS": "Συμπληρώστε έως &euro;150.",
		"CARD.ERROR.LOAD.VALUE.INPUT": "Η αξία του ποσού είναι πολύ μεγάλη.",
		"CARD.ERROR.TOO.MANY.CARDS.MOBILE": "You cannot order more than one rewards card for the same phone number (see line {name}).",

		seeMoreLabel: "MORE",
		seeLessLabel: "LESS",

		CNP: "employee ID",
		ADDRESS: "address code",
		NAME: "name",
		VOUCHERS: "vouchers",
		NOMINAL_VALUE: "nominal value",
		modifiyDataSucceess:
			"The new informations about the beneficiary were sucessfully modified.",
		deleteDataSucceess: "The beneficiary was successfully deleted",
		// Orders
		goToOrdersButton: "See all orders",
		details: "Details",
		pendingOrdersMessage: "{noOrders} orders waiting",
		pendingOrdersTitle: "Pending orders",
		replacementOrdersTitle: "Replacement orders",
		pendingOrdersNoOrders: "There are no pending orders",
		ordersHistoryTitle: "Orders history",
		cancelOrderButtonLabel: "Delete",
		trackOrderButtonLabel: "Track my order",
		reportButtonLabelPaper: "Voucher report",
		reportButtonLabelCard: "Card report",
		invoiceButtonLabel: "Invoice",
		proformaButtonLabel: "Proform",
		orderDescription: "Placed on ",
		companySettingsTitle: "Settings",
		VATLabel: "Fiscal number",
		deliveryAddressLabel: "Primary delivery address",
		invoiceAddressLabel: "Tax Office",
		changePasswordLabel: "Change password",
		changePasswordSuccess: "The password was successfully changed",
		errorPassword_PASS: "The new password is not equal with the confirmation.",
		errorPassword_500:
			"Server error. <br /> Please wait a few minutes and try again",
		invoicesFilterTitle: "Filter invoices",
		invoicesFilterProduct: "Product",
		invoicesFilterStatus: "Status",
		invoicesFilterPeriod: "Period",
		invoiceStatus_paid: "Paid",
		invoiceStatus_unpaid: "Unpaid",
		invoiceStatus_overdue: "Overdue",
		newOrderTitle: "New order",
		orderStep_1: "Order type",
		orderStep_2: "Product",
		orderStep_3: "Personalize",
		orderStep_4: "Confirm",
		orderStep_5: "Payment",
		orderStep_1_title: "What type of order do you want to place? ",
		orderStep_2_title: "Choose the Up product ",
		orderStep_3_title: "Personalize order ",
		orderStep_4_title: "Summary ",
		orderStep_5_title: "Payment ",
		orderTypePaper: "Paper vouchers",
		orderTypeCard: "Cards",
		orderTypeTopup: "Card loading ",
		orderTypeDuplicate: "Duplicate order ",
		orderAddBeneficiariesTitle: "Add beneficiaries",
		orderExcelTemplateTitle:
			"Personalize the structure of your uploaded Excel table",
		orderExcelColumnLabel: "Col. {index}:",
		orderExcelColumn_0: "Select...",
		orderExcelColumn_1: "First name",
		orderExcelColumn_2: "Last name",
		orderExcelColumn_3: "Delivery address",
		orderExcelColumn_4: "employee ID#",
		orderExcelColumn_5: "No of Vouchers 1",
		orderExcelColumn_6: "Amount 1",
		orderExcelColumn_7: "No of Vouchers 2",
		orderExcelColumn_8: "Amount 2",
		orderExcelColumn_9: "No of Vouchers 3",
		orderExcelColumn_10: "Amount 3",
		orderUploadFileTitle: "Upload your personalized order table",
		orderFileModelLabel: "Model:",
		orderFileUploadPlaceholder: "No file chosen",
		orderFileUploadButton: "Browse",
		orderFileModelText: "Download the personalized model file",
		orderFileUploadLabel: "Upload:",
		orderFileUploadText: "Fill out and upload the order file",
		orderAddFileButtonLabel: "Add",
		nextStepButtonLabel: "CONTINUE",
		saveOrderButtonLabel: "SAVE FOR LATER",
		orderDeliveryTitle: "Delivery options",
		orderDeliveryCourier: "Courier delivery",
		orderDeliveryPickup: "Pick-up from the Up Hellas headquarter",
		orderDetailsTitle: "Order {orderId} ",
		orderDetailsAddressLabel: "Invoice address: ",
		orderDetailsProductLabel: "Product ",
		orderDetailsNoCardsLabel: "Number of cards ordered ",
		orderDetailsNoTicketsLabel: "Number of vouchers ordered ",
		orderDetailsNominalValueLabel: "Total nominal value ",
		orderDetailsCommisionLabel: "Total commission value ",
		orderDetailsVatLabel: "Total VAT value ",
		orderDetailsDeliveryFeeLabel: "Total delivery fee value ",
		orderDetailsCardFeeLabel: "Total card fee value ",
		orderDetailsTotalValueLabel: "Total amount to be payed",
		orderDetailsDeliveryLabel: "Delivery points ",
		actionUploadFileSuccess:
			"The beneficiaries were successfully sent to the server.",
		orderSuccessMessage:
			"Thank you for your order. <br /> You can follow the status of this order in the Orders menu.",
		ordersButtonLabel: "Receive proforma",
		orderMonthLabel: "Top-up month",
		orderMonth_0: "Select...",
		orderMonth_1: "January",
		orderMonth_2: "February",
		orderMonth_3: "March",
		orderMonth_4: "April",
		orderMonth_5: "May",
		orderMonth_6: "June",
		orderMonth_7: "July",
		orderMonth_8: "August",
		orderMonth_9: "September",
		orderMonth_10: "Octomber",
		orderMonth_11: "November",
		orderMonth_12: "December",
		orderValidFromLabel: "Valid from",
		orderProformaDateLabel: "Proforma date",
		proformaType_NONE: "PROFORMA TODAY AND LOAD AT PAYMENT",
		proformaType_VALIDFROM: "PROFORMA TODAY AND LOAD IN THE FUTURE",
		proformaType_POSTPONE: "PROFORMA AT A LATER DATE",
		orderValidFromTitle: "Choose the charging date*",
		orderProformaDateTitle: "Choose the proforma date*",
		orderPurchaseOrderTitle: "Purchase order (max 20 characters)",
		orderGeneralCommentTitle: "General comment (max 50 characters)",
		orderPersonalizedLabel: "Personalized vouchers",
		orderNotPersonalizedLabel: "Not personalized vouchers",
		orderPersonalizeVouchersTitle: "Personalize the vouchers (optional)",
		orderPersonalizedIconLabel: "Logo",
		orderPersonalizedViewIconLabel: "See logo",
		orderPersonalizedPrintIconLabel: "Print on tichet",
		orderPersonalizedMessageLabel: "Message",
		orderPersonalizedGroupingLabel: "Voucher grouping",
		orderPersonalizedGroupingPlanse: "Board",
		orderPersonalizedGroupingPachet: "Free Vouchers",
		orderPersonalizedGroupingCarnet: "Booklet",
		orderStatus_A: "Canceled",
		orderStatus_N: "New",
		orderStatus_R: "Not confirmed",
		orderStatus_P: "Confirmed",
		orderStatus_E: "Error",
		orderStatus_PR: "Production",
		orderStatus_PV: "Production",
		orderStatus_S: "Storno",
		orderStatus_V: "Finished",
		orderStatus_V2: "At courier",
		orderStatus_Z: "Canceled",
		orderStatus_I: "Payment processing",
		orderPaymentStatusText: "Your payment is {data}",
		orderPaymentStatus_A: "aborted",
		orderPaymentStatus_P: "pending",
		orderPaymentStatus_V: "authorized",
		orderPaymentStatus_TO: "timed out",
		orderPaymentStatus_E: "in error",
		orderPaymentStatus_Z: "cancelled",
		orderPaymentStatus_AA: "aborted",
		orderPaymentStatus_TC: "in transaction",
		orderPaymentStatus_400: "not found",
		orderPaymentStatus_500: "in error. Please contact Up Hellas Team",
		orderPaymentStatus_: "",
		defaultAmountValue: "Amount for all employees ",
		manualOrderTabTitle: "Web",
		excelOrderTabTitle: "With Excel",
		orderError_DELETE:
			"A server error has occured. The order was not canceled.",
		orderError_PAYMENT:
			"The order payment request was not sent successfully. Please try again later.",
		orderError_PAY_LATER:
			"The proforma email was not sent successfully. Please try again later.",
		orderError_ALREADY:
			"The order you are trying to pay was already payed using Iris Online Payment.",
		orderError_NOTFOUND: "The order you are trying to pay does not exist.",
		orderError_UNAVAILABLE:
			"This option will be available this month. It will allow your cards to be charged in less than 30 minutes. In a few clicks.",
		orderDeleteSuccess: "The order was successfully canceled.",
		orderPayRedirect:
			"You will be redirected to the bank selection page. Please proceed with the payment in the new window.",
		orderPayLater:
			"Check your mailbox. Your proforma is sent to your email you defined to Up Hellas.",
		beneficiaryVoucherLabel: "Employee Name or Text on booklet",
		noOfBookletLabel: "No of booklets",
		noOfCardLabel: "No of cards",
		noOfCardLabelRewards: "No of cards",
		displayTextLabel: "Display text",
		cardCarrierTextLabel: "Card carrier info",
		employeeIdCardLabel: "employee ID# <br />(optional)",
		noTicketsValue1Label1: "No of tickets 1",
		amountVoucherLabelPaper: "Total amount (Automatic fill)",
		amountVoucherLabel: "Amount",
		amountVoucher1Label1: "Amount 1",
		noTicketsValue1Label2: "No of tickets ",
		amountVoucher1Label2: "Amount ",
		noTicketsValue2Label: "No of tickets 2",
		amountVoucher2Label: "Amount 2",
		noTicketsValue3Label: "No of tickets 3",
		amountVoucher3Label: "Amount 3",
		confirmOrderDelete: "Are you sure you want to cancel this order?",
		confirmOrderInfo:
			"Η πληρωμή σας είναι σε εξέλιξη. Παρακαλούμε μην κλείσετε της σελίδα του IRIS μέχρι να ανακατευθυνθείτε αυτόματα πίσω στην σελίδα της Up.",
		confirmOrderPay: "After you continue you will pay ",
		confirmOrderPay2: " for the order selected.",
		windowText: "Envelope line 1",
		windowText1: "Envelope line 1",
		windowText2: "Envelope line 2",
		windowText3: "Envelope line 3",
		windowText4: "Envelope line 4",
		noCrtLabel: "No.",
		orderTableHeaderLabel: "Order number",
		noProductContract:
			"This product is not available for you. You need first to sign an agreement with Up Hellas.",
		productHolidayInfo:
			"We would like to inform you that the tourism vouchers are no longer available.<br /> <br/>If you need more details, please contact the Account Manager of Up Hellas.",
		orderCardMessage:
			"* In order for an order to be processed the same (working) day, it should be integrated in the platform and paid until 17.00.",
		addBeneficiariesTitle: "Add new beneficiaries",
		addBeneficiariesTitleRewards: "Add new beneficiaries",
		searchPlaceholder: "search",
		digitalCardsMobileInfo: "* the mobile phone for all beneficiaries must be unique",
		chooseAllAddressOption: "All delivery places",

		pshysicalCardsTitle: "PHYSICAL CARDS",
		digitalCardsTitle: "DIGITAL CARDS",

		// search company
		searchName: "Company search",
		searchPageName: "Company search",
		searchByCodall: "Codall",
		searchByProduct: "Product",
		searchByCompanyName: "Company name",
		searchByFiscalCode: "Fiscal code",
		searchButtonLabel: "Search",
		searchNoCompanies: "There is no company for the selected criteria.",

		paymentButtonLabel: "Pay Now",

		bankingHoursMesage:
			"01/05/2024 οι πληρωμές που θα πραγματοποιούνται με διατραπεζικό έμβασμα (μεταφορά) θα εκτελούνται στις 02/05/2024  λόγω αργίας , συνεπώς τότε θα πραγματοποιούνται και οι φορτίσεις και τιμολογήσεις που έχουν εξοφληθεί με απλή μεταφορά. Για τις έγκαιρες φορτίσεις κατ' αυτό το διάστημα προτιμήστε τις πληρωμές μέσω IRIS ή RF.",
		ordersHistoryMessage:
			"Οι παραγγελίες που δεν έχουν οριστικοποιηθεί εντός 1 μήνα από τη δημιουργία τους, θα ακυρώνονται αυτόματα. <br />Αν επιθυμείτε να τις επαναλάβετε, μπορείτε να τις υποβάλετε εκ νέου.",
		millesimeMesage: "Due to scheduled upgrades on our platform, the order placement will be temporarily unavailable. It will be fully restored after 11:00. Thank you for your understanding.",
		"CARD.ERROR.MILLESIME": "Due to scheduled upgrades on our platform, the order placement will be temporarily unavailable. It will be fully restored after 11:00. Thank you for your understanding.",
		splitOrderMessage: "Έχετε πραγματοποιήσει μια παραγγελία που συμπεριλαμβάνει φυσικές και ψηφιακές κάρτες. Επιλέξτε PAY LATER και θα παραλάβετε άμεσα μέσω email τις δύο αντίστοιχες ειδοποιήσεις πληρωμής τις οποίες μπορείτε να εξοφλήσετε άμεσα κλικάροντας πάνω στον σύνδεσμο πληρωμής.",
		savedOrderMessage: "The order was successfully saved. You can confirm it anytime from the Order menu.",

		gecrNumber: "GECR (GEMI) Number : 136666001000",

		needHelpButton: "NEED HELP?",

		bigOrderMessage: "Your order contains a big number of cards. The process will take some minutes. Thank you for your patience. You will receive your proforma once your cardholders accounts are created.",
		loadingMessage: "Please wait. The information is being loaded	",

		// delivery points update
		warningCardAddressPoint: "*Any data changed for an electronic product shall automatically extend to all the productst!",
		sentAddressPointSuccess: "The delivery point was updated successfuly.",
		errorSentAddressPoint_NOT_SENT: "The delivery point could not be updated.",
		errorSentAddressPoint_ISSS: "The delivery point could not be updated.",
		errorSentAddressPoint_NOT_FOUND: "The delivery point does not exist.",
		errorSentAddressPoint_PHONE_NOT_VALID: "The mobile phone is not correct.",
		errorSentAddressPoint_EMAIL_NOT_VALID: "The email address is not correct.",

		generalErrorMessage: "Dear Customers, <br />We would like to inform you that transactions have been temporarily suspended due to a technical issue of Worldline. Our team is working diligently to resolve it, and we expect it to be restored soon. We ask for your understanding and thank you for your patience.",

	},
];
